import {ROUTES} from '../routes';
import {LogGroupDetail} from './log-group-detail';
import {LogsListing} from './logs-listing';
import {RouteObject} from 'react-router';
import {ProtectedRoute} from '../auth/require-authorization';

export const LogsRoutes: RouteObject = {
  path: ROUTES.ADMIN.LOGS.path,
  element: <ProtectedRoute role={'Global Admin'}/>,
  children: [
    {
      path: ROUTES.ADMIN.LOGS.INDEX.path,
      element: <LogsListing />
    },
    {
      path: ROUTES.ADMIN.LOGS.GROUPED_DETAIL.path,
      element: <LogGroupDetail />
    }
  ]
}